/* Digioh needs to use localstorage to acess pretty much any data.
 * This hook is used in a third party integration that will hide a
 * mailing list form if the user is already a flexcar member.
 */
export function digiohCreditLocalStore(credit: string) {
  localStorage?.setItem('digioh_credit_modal_last_input', credit);
}
